import { createStyles, Theme } from "@material-ui/core";

export const styles = ({spacing}: Theme) => createStyles({
    button: {
        margin: 0
    },
    buttonLabel: {
        marginRight: spacing.unit,
        marginLeft: spacing.unit,
        textTransform: "initial"
    }
});


// WEBPACK FOOTER //
// ./src/components/QuotationActions/QuotationActions.style.tsx